import { IProductCategoriesRestService } from "@modules/product/categories/rest/product-categories-rest";
import { ProductDetailObjectTree } from "./product-detail-object-tree";
import { IProductDetailController, IPropertyService, ISnapshotObj, IbreadcrumbProduct } from "./product-detail";

export class ProductDetailManager {

    public static readonly $inject: string[] = ["$objectTree", "productCategoriesRestService", "$q", "propertyService"];

    constructor(
        public $objectTree: ProductDetailObjectTree,
        public productCategoriesRestService: IProductCategoriesRestService,
        public $q: angular.IQService,
        public propertyService: IPropertyService,
    ) {

    }

    private context: IProductDetailController;

    private setContext(context: IProductDetailController) {
        this.context = context
    }

    /**
     * @description
     * @returns 
     */
    public checkUrlParams(): boolean {
        return true
    }

    public initObjectTree(objectTree) {

    }

    // 获取默认PropertyModel
    public getDefaultProperty(productId: number) {
        this.propertyService.getProductProperty(productId)
    }

    /**
     * @description 获取面包屑数据
     */
    public getBreadcrumbViewValue(productId: number): angular.IPromise<Array<IbreadcrumbProduct>> {
        const def = this.$q.defer<Array<IbreadcrumbProduct>>();

        let breadcrumb;
        // 获取当前产品所在类目层级
        this.productCategoriesRestService.getCategories(productId).then(res => {
            const catalog = this.bubbleSort(res.data);

            // 面包屑配置数据--路由地址(记录当前page路径地址前缀，用于子类目路由配置地址url)
            let pagePathStr: string;
            catalog.forEach((item, index) => {
                // 当前关联产品类目对应的路由配置地址
                let pagePath: string = '';
                // 过滤pageName的“.html”字符
                if (item.pageName) {
                    item.pageName = item.pageName.replace('.html', '');
                } else {
                    const errorMsg = `productName:${item.name}, product Details CMS Release configuration Missing "pageName".`
                    this.context.sendError('product-detail.manager.breadcrumbOninit()', errorMsg);
                    return;
                }
                // 创建面包屑产品类目配置数据--父类目（pageName/all），index==0时，当前产品类目为该产品类目的父节点
                if (index == 0) {
                    pagePathStr = item.pageName;
                    pagePath = pagePathStr + '/all';
                }
                // 创建面包屑产品类目配置数据--子类目（parentPageName/childPageName），当前产品类目为该产品类目的非父节点
                if (index > 0) {
                    pagePathStr = pagePathStr + '/' + item.pageName;
                    pagePath = pagePathStr;
                }
                // 生成面包屑产品类目配置数据
                if (pagePath.length > 0) {
                    let breadcrumbItem = {
                        name: item.name as string,
                        id: item.id as number,
                        pagePath: pagePath
                    }
                    breadcrumb.push(breadcrumbItem);
                }
            })
            def.resolve(breadcrumb);
        }, error => {
            this.context.onRequestFail(error);
        })

        return def.promise;
    }

    /**
     * @description 面包屑树结构处理
     * @param source 
     * @returns 
     */
    private bubbleSort(source: Array<any>) {
        // 先找出根结点
        for (let j = 0; j < source.length; j++) {
            if (source[j].parentId == undefined) {
                let first = source[0];
                source[0] = source[j];
                source[j] = first;
            }
        }
        // 先找出第一个子结点
        for (let a = 1; a < source.length; a++) {
            if (source[a].parentId == source[0].id) {
                let first = source[1];
                source[1] = source[a];
                source[a] = first;
            }
        }
        // 冒泡,查找父节点并排序
        for (let i = 1; i < source.length; i++) {
            for (let j = 2; j < source.length; j++) {
                if (source[i].parentId && source[i].id == source[j].parentId) {
                    let child = source[j];
                    source[j] = source[i + 1];
                    source[i + 1] = child;
                } else {
                    continue;
                }
            }
        }
        return source;
    }

    /**
     * @description 创建本地缓存key（属性键值对字符串）
     * @param attributeValues 
     * @returns 
     */

    private creatAttributeSnapshot(attributeValues: Array<qpmn.product.model.domain.IAttributeValue>): ISnapshotObj {
        let snapshot = {}
        attributeValues.forEach(item => {
            snapshot[item.attributeId] = item.optionIds ? item.optionIds : item.value;
        })
        return snapshot;
    }
}